import React from "react";
import Seo from "../Components/Seo.jsx";

import poet from "../assets/Images/poet.jpg";
import { tamilAnthem } from "../constants/data";
import PageHeader from "../Components/PageHeader";

export default function TamilAnthem({}) {
  return (
    <>
      <Seo path="/tamil-anthem/" />

      <div className="container-fluid p-0">
        <PageHeader
          breadcrumbs={[
            { label: "Home", href: "/", icon: "bi-house", active: false },
            {
              label: "தமிழ்மொழி வாழ்த்து",
              href: "/tamil-anthem/",
              active: true,
            },
          ]}
        />
        <div className="container py-5">
          <div
            lang="ta"
            className="poster-a4 tamil-font mx-auto col-12 col-md-10 col-lg-8 rounded-5 border-bottom-left p-5"
            style={{ background: "#efece7" }}
          >
            <h1 className="fw-bold text-center red-text display-6 mb-3">
              தமிழ்மொழி வாழ்த்து
            </h1>

            <div className="d-flex justify-content-center">
              <img
                src={poet}
                alt="Portrait of the poet Subramania Bharati"
                className="img-fluid"
                style={{ maxWidth: 280 }}
              />
            </div>

            <div className="text-center">
              {tamilAnthem.map((stanza, i) => (
                <p key={i} className="verse-line fw-semibold mb-3">
                  {stanza.split("\n").map((line, j) => (
                    <React.Fragment key={j}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
